/// <reference types="vite-plugin-svgr/client" /> // For SVG imports
import { PublicClientApplication } from '@azure/msal-browser';

import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.tsx';
import APP_CONFIG from './_config/config.app.ts';
import './index.css';

const bootstrap = async () => {
  const msalInstance = new PublicClientApplication(APP_CONFIG.MSAL);
  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <App instance={msalInstance} />
    </React.StrictMode>,
  );
};

bootstrap();
